module.exports = __webpack_public_path__ + "img/statistics_filled_64.8571d835.svg";